var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard',{attrs:{"simulator-url-name":"julho_14.simulator","sidebar-items":_vm.$options.sidebar,"loading":_vm.loading,"loading-text":"Carregando dados de 14 de Julho, aguarde..."}},[_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }